exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".menu-footer-1{fill:#f0f9f8}.menu-footer-2{fill:none}.menu-footer-3{fill:#fff}.menu-footer-4{fill:#1f4d69}.menu-footer-5{fill:#ee7470}.menu-footer-6{fill:#e6e6e6}\n", ""]);
